let balikovnaDiv: HTMLDivElement | null = null;

function processResponse(event: MessageEvent) {
    if (event.data.message === 'pickerResult') {
        console.log(event.data);
        getLocationInput()!.value = JSON.stringify({balikovnaPoint: event.data.point});
        setBalikovnaName(event.data.point.name);
        removeMap();
    }
    // nastavit hodnoty
    // smazat iframe
}

function getLocationInput(): HTMLInputElement | null {
    return document.querySelector('input[name="deliveryLocation"]');
}

function getBalikovnaInput(): HTMLInputElement | null {
    return document.querySelector('[data-delivery-type="Balíkovna"]');
}

function setBalikovnaName(name: string): void {
    if (name !== '') {
        name = 'Pobočka: ' + name;
    }

    const balikovnaInput = getBalikovnaInput();
    if (balikovnaInput !== null && balikovnaInput.form !== null) {
        balikovnaInput.form.querySelector('[data-delivery-location="'+balikovnaInput.value+'"]')!.innerHTML = name;
    }
}

function openMapIfNeeded(event: Event): void {
    const target = event.target as HTMLInputElement;
    const isDeliveryMethodCheckbox = target.type === 'checkbox' && target.name === 'deliveryMethod';
    if (isDeliveryMethodCheckbox) {
        if (target.dataset.deliveryType === 'Balíkovna' && target.checked) {
            openMap();
        } else {
            removeMap();
            getLocationInput()!.value = '';
            setBalikovnaName('');
        }
    }
}

function openMap(): void {
    // Vytvoříme obalující div, pokud ještě neexistuje
    if (!balikovnaDiv) {
        balikovnaDiv = document.createElement('div');
        balikovnaDiv.style.position = 'fixed';
        balikovnaDiv.style.top = '0';
        balikovnaDiv.style.left = '0';
        balikovnaDiv.style.width = '100%';
        balikovnaDiv.style.height = '100%';
        balikovnaDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        balikovnaDiv.style.zIndex = '10000';
        balikovnaDiv.style.display = 'flex';
        balikovnaDiv.style.justifyContent = 'center';
        balikovnaDiv.style.alignItems = 'center';
        balikovnaDiv.addEventListener('click', function (event: MouseEvent): void {
          if (event.target === balikovnaDiv) {
            removeMap();
          }
        });

        // Vytvoříme iframe
        const iframe: HTMLIFrameElement = document.createElement('iframe');
        iframe.src = 'https://b2c.cpost.cz/locations/?type=BALIKOVNY';
        iframe.width = '80%';
        iframe.height = '80%';
        iframe.allow = 'geolocation';

        // Vytvoříme tlačítko pro smazání
        const tlacitkoSmazat: HTMLButtonElement = document.createElement('button');
        tlacitkoSmazat.innerText = 'Zavřít balíkovnu';
        tlacitkoSmazat.style.position = 'absolute';
        tlacitkoSmazat.style.top = '20px';
        tlacitkoSmazat.style.right = '20px';
        tlacitkoSmazat.style.padding = '10px 15px';
        tlacitkoSmazat.style.cursor = 'pointer';
        tlacitkoSmazat.style.zIndex = '1001'; // Aby bylo tlačítko nad průhledným pozadím
        tlacitkoSmazat.style.pointerEvents = 'auto'; // Aby na něj šlo kliknout
        tlacitkoSmazat.addEventListener('click', removeMap); // Používáme samostatnou funkci

        // Přidáme iframe a tlačítko do obalujícího divu
        balikovnaDiv.appendChild(iframe);
        balikovnaDiv.appendChild(tlacitkoSmazat);

        // Přidáme obalující div do body elementu
        document.body.appendChild(balikovnaDiv);
    } else if (balikovnaDiv.style.display === 'none') {
        // Pokud už div existuje, ale je skrytý, zobrazíme ho
        balikovnaDiv.style.display = 'flex';
    }
}

function removeMap(): void {
    if (balikovnaDiv) {
        balikovnaDiv.remove();
        balikovnaDiv = null; // Resetujeme proměnnou, aby se při dalším zavolání vytvořil nový div
    }
}

function initialize() {
    const balikovnaAvailable: HTMLInputElement | null = getBalikovnaInput();

    if (balikovnaAvailable !== null) {
        balikovnaAvailable.form?.addEventListener('change', openMapIfNeeded);
        window.addEventListener('message', processResponse);
    }
}

document.addEventListener("DOMContentLoaded", function() {
    initialize();
});
